import { getEdgeFunctionHeaders } from '../supabase';
import { fileToBase64 } from './excel-process';

export interface ExcelExample {
  base64Data: string;
  selectedSheet: string;
  filename: string;
}

export interface GenerateIntegrationRequest {
  receiverName: string;
  examples: ExcelExample[];
  extraInstructions?: string;
}

export interface GenerateIntegrationResponse {
  success: boolean;
  code?: string;
  error?: string;
}

export const generateIntegration = async (
  request: GenerateIntegrationRequest
): Promise<GenerateIntegrationResponse> => {
  try {
    const response = await fetch(
      `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/generate-integration`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(await getEdgeFunctionHeaders()),
        },
        body: JSON.stringify(request),
      }
    );

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to generate integration');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error generating integration:', error);
    throw error;
  }
};

export { fileToBase64 };
